export default __webpack_public_path__ + "static/media/IMG_2187.a23ff33a.jpg";